import {Injectable} from '@angular/core';
import {UserDto} from "../../dtos/userDto";
import {RootService} from "../root.service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({
	providedIn: 'root'
})
export class UsersService extends RootService {

	users: Array<UserDto> = [];
	
	constructor(public http: HttpClient) {
		super(http);
		let usersStorage = JSON.parse(localStorage.getItem('users'));
		if (this.users.length == 0 && usersStorage) {
			this.users = usersStorage;
		}
	}
	
	getUserById(userId: number) {
		return new Promise((resolve) => {
			resolve(this.users[this.users.findIndex(x => x.id == userId)]);
		})
	}
	
	getUserByLogin(userLogin: string) {
		return this.users[this.users.findIndex(x => x.login == userLogin)];
	}
	
	getUserContactByUserId(userId: number) {
		return this.http.get(this.URL + 'user-contacts/userId/' + userId);
	}

    getUserByCompanyId(companyId: number) {
        return this.http.post(this.URL + 'users/batching/' + companyId, []);
    }

    getUsers() {
        return this.http.get(this.URL + 'users?page=0&size=1000');
    }

	createUser(user: any) {
		return this.http.post(this.URL + 'register', user);
	}

	updateUser(user: UserDto) {
		return this.http.put(this.URL + 'users', user);
	}

	deactivateUser(user: UserDto) {
		return this.http.put(this.URL + 'users', user);
	}

	changePassword(login: string, newPassword: string) {
		return this.http.post(this.URL + 'account/change-password/wild', {
			login: login,
			newPassword: newPassword
		});
	}

}
